<template>
  <div class="flex flex-wrap justify-between mb-[30px] px-[10px] h-full mx-auto mt-[20px] min-h-[456px] min-w-[1440px] max-w-[1450px]">
    <!--plans-->
    <div class="w-[67%] box-border">

      <!-- time -->
      <div class="w-full bg-white shadow-[0_2px_15px_0_#dbe2f180] rounded-[8px] flex justify-between items-center proxy-time">
        <div v-for="(item, index) in typeArr" 
          class="h-[67px] flex justify-center items-center shrink grow cursor-pointer"
          :class="[item.type == localPackageType ? 'border border-[#EE3237] border-t-[8px] bg-[#ee32370d] rounded-[4px]' : '',]" 
          @click="changeTabType(item.type)">
          <div class="w-full h-[80%] flex justify-center items-center text-[18px] text-[#223265]">
            <div v-if="item.type == 'test'" v-cloak>
              <el-tooltip class="item" effect="dark" :content="$t('cpts.buy_isp.free_max_ips', {maxIps: maxTestIps})" placement="top-start">
                <el-badge :value="maxTestIps" class="item">
                {{ $t(`cpts.buy_isp.periods.${item.type}`) }}
                </el-badge>
              </el-tooltip>
            </div>
            <div v-else v-cloak>
              {{ $t(`cpts.buy_isp.periods.${item.type}`) }}
            </div>
          </div>
        </div>
      </div>

      <!--skus-->
      <div class="mt-[24px] w-full pb-[25px] pl-[26px] box-border bg-white rounded-[10px] shadow-[0_2px_15px_0_#dbe2f180] overflow-hidden proxy-skus">
        <!--top-->
        <div class="w-full shrink-0 mb-[17px] py-[12px] pr-[26px] border-b border-[#EFF1F6] shadow-none box-border flex justify-between items-center flex-wrap">
          <div class="text-[18px] leading-[38px] text-[#223265]">
            <span>{{ $t("cpts.buy_isp.regions_title") }}</span>
          </div>
          <div>
            <div class="isp-search-control relative w-auto flex items-center justify-end">
              <i class="el-icon-search z-2 w-[20px] h-[20px] text-[#1c3b3b] absolute left-[10px] top-[50%] translate-y-[-50%]"></i>
              <input class="isp-search-input relative z-1 w-[350px] h-[38px] pl-[40px] pr-[80px] py-[20px] box-border mx-auto border border-slate-300 rounded-[2px] bg-transparent text-[#A9AFB7] transition-all" type="text" :placeholder="$t('cpts.buy_isp.search_placeholder')"
                v-model="searchInfo.code">
              <button type="button" @click="toObtainPlan" class="isp-search-button absolute right-0 top-0 bottom-0 z-2 w-[78px] rounded-r-[4px] text-[13px] leading-[38px] text-white bg-[#1c3b3bd1] border-none font-medium cursor-pointer">{{ $t("cpts.buy_isp.search") }}</button>
            </div>
          </div>
        </div>

        <!--plans-->
        <div class="proxy-plans-container relative w-full h-[545px] max-h-[545px] min-h-0">
          <div ref="plansScroll" class="proxy-plans-scroll w-full h-full overflow-y-auto" v-loading="loading" @scroll="updatePlansScrollHint">
            <el-collapse v-model="expandedPanels" @change="updatePlansScrollHint">
            <!-- area -->
            <el-collapse-item v-for="(item, index) in localStaticCountryInfo" :key="index" :name="item.name">
              <template slot="title">
                <div class="w-full text-[18px] text-[#223265] leading-none">
                  <i class="el-icon-caret-bottom hidden"></i>
                  <i class="el-icon-caret-right"></i>
                  <span>{{ item.name }}</span>
                </div>
              </template>
              <div class="w-full flex justify-start flex-wrap">
                <!--country item-->
                <div v-for="(v, i) in item.child" :key="i"
                  :class="['relative group flex-none mr-[23px] mt-[16px] w-[184px] py-[8px] px-[30px] shadow-md rounded-[4px] border border-[#E6EFFB] opacity-100 box-border hover:bg-[#FEF5F5] hover:border hover:border-[#EE3237]',
                          v.num > 0 ? 'active' : '', v.hot == 1 ? 'hot' : '']">
                  <div class="absolute right-0 top-[-8px]">
                    <el-badge v-if="v.isp !== ''" :value="v.isp" type="info"></el-badge>
                  </div>
                  <div class="mb-[8px] w-full box-border text-[12px] text-[#223265] text-center leading-none" v-cloak v-html="v.country_name_sp"></div>
                  <div class="w-full h-[22px] box-border" :class="[v.stock == 0 ? 'country-noinfo' : '']">
                    <div class="hidden w-full h-full" v-cloak>
                      <button class="w-full h-full bg-[#276DFD] rounded-[2px] border-none box-border text-[12px] font-medium text-white cursor-pointer" @click="openWechatQr">
                        <span>Contact us</span>&ensp;<i class="el-icon-right"></i>
                      </button>
                    </div>
                    <div class="w-full h-full flex justify-between items-center text-[12px] font-medium group-hover:hidden">
                      <div v-cloak><span class="text-[#223265b3]">{{ $t('cpts.buy_isp.stock') }}</span><span class="text-[#276DFD]">{{ v.stock }}</span>
                      </div>
                      <div class="text-[14px] text-[#FA941B]" v-cloak><span>$</span><span>{{ v[localPackageType +
                          '_price'] }}</span><span>/IP</span></div>
                    </div>
                    <!--editor-->
                    <div class="hidden w-full h-full group-hover:block" v-cloak>
                      <div class="w-full h-full relative bg-white rounded-[2px]">
                        <div class="absolute top-0 left-0 z-10 w-[22px] h-full rounded-tl-[2px] border border-[#EE3237] box-border flex items-center justify-center cursor-pointer" @click="decIPNum(index, i)" @mousedown="decIPNumReduce(index, i)"
                          @mouseup="decIPNumReduceStop(index, i)" @mouseleave="decIPNumReduceStop(index, i)">
                          <img src="@/assets/index/img/pay/dec_no.svg" alt="dec" class="block">
                          <img src="@/assets/index/img/pay/dec_act.svg" alt="dec" class="hidden">
                        </div>
                        <input v-model="v.num" type="text" name="" :readonly="isReadOnly(v.stock)" class="m-0 w-full h-full absolute top-0 left-0 right-0 border-none outline-0 rounded-[2px] px-[25px] box-border text-center text-[#223265]"
                          @input="changeInputNum(index, i)">
                        <div class="absolute top-0 right-0 z-10 w-[22px] h-full rounded-br-[2px] border border-[#EE3237] box-border flex items-center justify-center cursor-pointer" @click="addIPNum(index, i)" @mousedown="addIPNumplus(index, i)"
                          @mouseup="addIPNumPlusStop(index, i)" @mouseleave="addIPNumPlusStop(index, i)">
                          <img src="@/assets/index/img/pay/add_no.svg" alt="add" class="block">
                          <img src="@/assets/index/img/pay/add_act.svg" alt="add" class="hidden">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            </el-collapse>
          </div>
          <button
            v-show="showPlansScrollHint"
            type="button"
            class="proxy-scroll-hint"
            aria-label="Scroll down to see more regions"
            @click="scrollPlansDown"
          >
            <i class="el-icon-arrow-down"></i>
          </button>
        </div>
      </div>
    </div>

    <!--summary-->
    <div class="w-[30%] bg-white rounded-[10px] h-[750px] max-h-[750px] shadow-[0_2px_15px_0_#dbe2f180] proxy-summary">
      <div class="h-full flex flex-col">
        <div class="text-[26px] leading-[22px] pt-[20px] pr-[34px] pb-[16px] pl-[34px] border-b-[1px] border-b-[#EFF1F6] text-[#213265]">
          {{ $t("cpts.buy_isp.summary") }}
        </div>
        <!--cart-->
        <div class="pt-[8px] mb-[12px] flex-1 min-h-0 overflow-y-auto">
          <!--shopping-list-->
          <div class="pl-[34px] pr-[25px]" v-for="(item, index) in localChooseRegionArr" :key="index">
            <div class="flex items-center justify-between flex-wrap border-b border-b-[#F6F7FA] py-[14px]">
              <!-- name -->
              <div class="flex items-center flex-wrap">
                <div class="text-[12px] font-medium leading-none mr-[8px] text-[#213265]" v-cloak>
                  <span v-html="item.country_name_sp"></span>
                  <span v-if="item.isp"> ({{ item.isp }})</span>
                </div>
                <div class="w-[82px] h-[24px] box-border text-[#F58143] bg-[#ff955c1a] border border-[#fa951a1a] rounded-[12px] px-[11px] pl-[6px] text-center leading-[24px] font-medium text-[12px]" v-cloak><span>$</span><span>{{ item[localPackageType +
                    '_price']}}</span><span>/IP</span></div>
              </div>
              <div class="w-[100px] h-[20px]">
                <div class="w-full h-full relative bg-white" v-cloak>
                  <div class="absolute top-0 left-0 z-10 w-[20px] h-[20px] box-border flex items-center justify-center cursor-pointer" 
                    @click="cartDecIPNum(index)" @mousedown="cartDecIPNumReduce(index)"
                    @mouseup="cartDecIPNumReduceStop(index)" @mouseleave="cartDecIPNumReduceStop(index)">
                    <img src="@/assets/index/img/pay/shop-dec.svg" alt="dec" class="act">
                  </div>
                  <input v-model="item.num" type="text" name="" @input="cartChangeInputNum(index)" class="m-0 w-full h-full absolute top-0 left-0 right-0 border-none outline-0 rounded-[2px] px-[25px] box-border text-center text-[#223265]">
                  <div class="absolute top-0 right-0 z-10 w-[20px] h-[20px] cursor-pointer" 
                    @click="cartAddIPNum(index)" @mousedown="cartAddIPNumPlus(index)"
                    @mouseup="cartAddIPNumPlusStop(index)" @mouseleave="cartAddIPNumPlusStop(index)">
                    <img src="@/assets/index/img/pay/shop-add.svg" alt="add" class="act">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--total-->
        <div class="proxy-summary-footer shrink-0 px-[34px] pb-[24px]">
          <div v-if="showSummerPromotion" class="summer-static-promo">
            <div>
              <strong>{{ $t('activity.summer.payment_title') }}</strong>
              <span>{{ promotionAppliedText }}</span>
            </div>
            <em>{{ $t('activity.summer.save') }} ${{ promotionSaving }}</em>
          </div>
          <div v-if="showSummerPromotion" class="mb-[6px] text-[13px] text-[#5f7472] flex justify-between">
            <span>{{ $t("cpts.checkout.subtotal") }}</span>
            <span>${{ displayOriginalTotal }}</span>
          </div>
          <div class="mb-[16px] flex justify-between items-center">
            <span class="mr-[15px]">{{ $t("cpts.buy_isp.total") }} </span>
            <span class="text-[18px] font-bold text-[#173b3a]">
              $<span class="font-serif oldstyle-nums slashed-zero" v-cloak>{{ displayPayableTotal }}</span>
            </span>
          </div>
          <div class="text-center">
            <a class="static-isp-checkout-btn inline-block w-[197px] h-[46px] bg-[#EE3237] shadow-xl rounded-[8px] text-[20px] font-bold text-white leading-[46px] text-center relative cursor-pointer" 
              @click="buyNow" target="_blank">{{ $t("cpts.buy_isp.checkout") }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getIspPackages } from '@/http/api/home'
import { getUserAuthorities } from '@/http/api/member'
import { calculatePromotionDiscount, isPromotionEligibleType, promotionConfig, promotionText } from '@/config/site-theme'

export default {
  name: "isp-proxiy-view",
  data() {
    return {
      loading: false,
      
      typeArr: [
        {
          showname: "WEEK",
          type: "weekly",
        },
        {
          showname: "BIWEEKLY",
          type: "fortnightly",
        },
        {
          showname: "MONTHLY",
          type: "monthly",
        },
        {
          showname: "BIMONTHLY",
          type: "bimonthly",
        },
        {
          showname: "QUARTERLY",
          type: "quarterly",
        },
      ],
      searchInfo: {
        code: ""
      },
      expandedPanels: [],
      changeNumTime: '',
      changeNumIntervals: '',
      maxTestIps: 0,
      showPlansScrollHint: false,

      localPackageType: 'weekly',
      localStaticCountryInfo: [],
      localChooseRegionArr: [],
      localTotalInfo: {
        total: 0,
      },
    }
  },
  props: {
    code: {
      type: String,
      default: ''
    },
  },
  watch: {
    code: {
      handler(newVal, oldVal) {
        // console.log('searchInfo.code' + newVal)
        this.searchInfo.code = newVal;
        this.toObtainPlan();
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      staticPackageType: state => state.cart.staticPackageType,
      chooseRegionArr: state => state.cart.chooseRegionArr,
      totalInfo: state => state.cart.totalInfo,
      staticCountryInfo: state => state.cart.staticCountryInfo,
    }),
    isReadOnly(value) {
      return (value) => value === 0;
    },
    isLogin() {
      return this.$store.state.isLogin
    },
    showSummerPromotion() {
      return isPromotionEligibleType(2) && this.localPackageType !== 'test' && Number(this.localTotalInfo.total || 0) > 0;
    },
    autoCouponCode() {
      return promotionConfig.code;
    },
    promotionAppliedText() {
      return promotionText(this, 'payment_applied');
    },
    displayOriginalTotal() {
      return this.formatMoney(this.localTotalInfo.total);
    },
    promotionSaving() {
      const total = Number(this.localTotalInfo.total || 0);
      const saving = calculatePromotionDiscount(total);
      return this.formatMoney(saving);
    },
    displayPayableTotal() {
      if (!this.showSummerPromotion) {
        return this.displayOriginalTotal;
      }
      const total = Number(this.localTotalInfo.total || 0);
      const saving = calculatePromotionDiscount(total);
      return this.formatMoney(Math.max(0, total - saving));
    },
  },
  created() {
    this.searchInfo.code = this.code;

    this.loadCartData()
    if (this.isLogin) {
      this.loadUserAuthories()
    }
    this.toObtainPlan()
    // 监听localStorage变化，用于处理语言切换
    window.addEventListener('storage', this.onLanguageChange);
  },
  mounted() {
    window.addEventListener('resize', this.updatePlansScrollHint);
    this.updatePlansScrollHint();
  },
  destroyed() {
    window.removeEventListener('storage', this.onLanguageChange);
    window.removeEventListener('resize', this.updatePlansScrollHint);
  },
  methods: {
    ...mapMutations('cart', ['setCart']),
    openWechatQr() {
      window.dispatchEvent(new CustomEvent('open-wechat-qr'));
    },
    updatePlansScrollHint() {
      this.$nextTick(() => {
        const scrollArea = this.$refs.plansScroll;
        if (!scrollArea) return;
        this.showPlansScrollHint = scrollArea.scrollTop + scrollArea.clientHeight < scrollArea.scrollHeight - 2;
      });
    },
    scrollPlansDown() {
      const scrollArea = this.$refs.plansScroll;
      if (!scrollArea) return;
      scrollArea.scrollBy({ top: Math.max(160, scrollArea.clientHeight * 0.65), behavior: 'smooth' });
    },
    loadCartData() {
      this.localPackageType = this.staticPackageType
      this.localChooseRegionArr = this.chooseRegionArr;
      this.localTotalInfo = this.totalInfo;
      this.localStaticCountryInfo = this.staticCountryInfo;
    },
    saveCartData() {
      const cart = {
        staticPackageType: this.localPackageType,
        chooseRegionArr: this.localChooseRegionArr,
        totalInfo: this.localTotalInfo,
        staticCountryInfo: this.localStaticCountryInfo
      };
      this.$store.commit('cart/setCart', cart);
    },
    onLanguageChange(event) {
      if (event.key === 'language') {
        clearTimeout(this.languageChangeTimer);
        this.languageChangeTimer = setTimeout(() => {
          this.toObtainPlan();
        }, 300); // 300ms防抖延迟
      }
    },

    buyNow: function () {
      let that = this;
      if (that.localChooseRegionArr.length > 0) {
        let location = that.localChooseRegionArr.length;
        let amount = 0;
        let static_commodity = "";
        for (let i = 0; i < that.localChooseRegionArr.length; i++) {
          amount += Number(that.localChooseRegionArr[i].num);
          static_commodity += `${that.localChooseRegionArr[i].id}:${Number(that.localChooseRegionArr[i].num)}`;
          if (i < (that.localChooseRegionArr.length - 1)) {
            static_commodity += "|";
          }
        }
        
        // when localPackageType is test check amount <= maxTestIps
        if (that.localPackageType == 'test') {
          if (amount > that.maxTestIps) {
            that.$message({
              message: that.$t('buy_isp.messasge.exceed_test_limit', that.maxTestIps),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }

        let item = {
          type: 2,
          money: that.localTotalInfo.total,
          location: location,
          amount: amount,
          static_commodity: static_commodity,
          date_unit: that.localPackageType,
        }

        this.$emit('buy-now', item)
      }
    },
    
    changeTabType: function (type) {
      let that = this;
      that.localPackageType = type;
      that.refreshChooselocalTotalInfo()
    },
    changeInputNum: function (continentIndex, regionIndex) {
      let that = this;
      let del = false;
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num;
      if (num !== '' && num[0] === '0') {
        num = num.slice(1);
      }
      const pattern = /^[1-9]\d*$/;
      if (!pattern.test(num)) {
        num = 0;
        del = true;
      } else {
        let maxNum = that.localStaticCountryInfo[continentIndex].child[regionIndex].stock;
        if (num > maxNum) {
          num = maxNum;
        } else if (num == 0) {
          num = 0;
          del = true;
        } else if (num < 0) {
          num = 0;
          del = true;
        }
      }
      that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num;
      let id = that.localStaticCountryInfo[continentIndex].child[regionIndex].id;
      if (del) {
        if (that.localChooseRegionArr.length > 0) {
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              that.localChooseRegionArr.splice(i, 1);
            }
          }
        }
      } else {
        if (num > 0) {
          if (that.localChooseRegionArr.length > 0) {
            let isadd = true
            for (let i = 0; i < that.localChooseRegionArr.length; i++) {
              if (id == that.localChooseRegionArr[i].id) {
                isadd = false
                let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
                obj.continentIndex = continentIndex
                obj.regionIndex = regionIndex
                that.localChooseRegionArr[i] = obj
              }
            }
            if (isadd) {
              let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
              obj.continentIndex = continentIndex
              obj.regionIndex = regionIndex
              that.localChooseRegionArr.push(obj)
            }
          } else if (that.localChooseRegionArr.length == 0) {
            let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
            obj.continentIndex = continentIndex
            obj.regionIndex = regionIndex
            that.localChooseRegionArr.push(obj)
          }
        }
      }
      that.refreshChooselocalTotalInfo()
    },
    decIPNum: function (continentIndex, regionIndex) {
      let that = this;
      let del = false
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num
      num--
      if (num > 0) {
        that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num
      } else if (num == 0) {
        that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num
        del = true
      } else {
        del = true
      }
      let id = that.localStaticCountryInfo[continentIndex].child[regionIndex].id;
      if (del) {
        if (that.localChooseRegionArr.length > 0) {
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              that.localChooseRegionArr.splice(i, 1);
            }
          }
        }
      } else {
        if (num > 0) {
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
              obj.continentIndex = continentIndex
              obj.regionIndex = regionIndex
              that.localChooseRegionArr[i] = obj
            }
          }
        }
      }
      that.refreshChooselocalTotalInfo()
    },
    addIPNum: function (continentIndex, regionIndex) {
      let that = this;
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num
      let maxNum = that.localStaticCountryInfo[continentIndex].child[regionIndex].stock
      if (num < maxNum) {
        num++
        that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num;
      }

      let id = that.localStaticCountryInfo[continentIndex].child[regionIndex].id;

      if (num > 0) {
        if (that.localChooseRegionArr.length > 0) {
          let isadd = true
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              isadd = false
              let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
              obj.continentIndex = continentIndex
              obj.regionIndex = regionIndex
              that.localChooseRegionArr[i] = obj
            }
          }
          if (isadd) {
            let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
            obj.continentIndex = continentIndex
            obj.regionIndex = regionIndex
            that.localChooseRegionArr.push(obj)
          }
        } else if (that.localChooseRegionArr.length == 0) {
          let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
          obj.continentIndex = continentIndex
          obj.regionIndex = regionIndex
          that.localChooseRegionArr.push(obj)
        }
      }
      that.refreshChooselocalTotalInfo()
    },
    decIPNumReduce: function (continentIndex, regionIndex) {
      let that = this
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num
      that.changeNumTime = setTimeout(() => {
        that.changeNumIntervals = setInterval(() => {
          if (num > 0) {
            num--
          } else {
            that.clearChangeTime()
            return false
          }
          that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num
        }, 100);
      }, 500);
    },
    decIPNumReduceStop: function (continentIndex, regionIndex) {
      let that = this
      let del = false
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num;
      if (num == 0) {
        del = true
      }
      let id = that.localStaticCountryInfo[continentIndex].child[regionIndex].id;
      if (del) {
        if (that.localChooseRegionArr.length > 0) {
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              that.localChooseRegionArr.splice(i, 1);
            }
          }
        }
      } else {
        if (num > 0) {
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
              obj.continentIndex = continentIndex
              obj.regionIndex = regionIndex
              that.localChooseRegionArr[i] = obj
            }
          }
        }
      }
      that.clearChangeTime()
      that.refreshChooselocalTotalInfo()
    },
    addIPNumplus: function (continentIndex, regionIndex) {
      let that = this
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num
      let maxNum = that.localStaticCountryInfo[continentIndex].child[regionIndex].stock
      that.changeNumTime = setTimeout(() => {
        that.changeNumIntervals = setInterval(() => {
          if (num < maxNum) {
            // num = maxNum
            num++
          } else {
            that.clearChangeTime()
            return false
          }
          that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num
        }, 100);
      }, 500);
    },
    addIPNumPlusStop: function (continentIndex, regionIndex) {
      let that = this
      let num = that.localStaticCountryInfo[continentIndex].child[regionIndex].num;
      let id = that.localStaticCountryInfo[continentIndex].child[regionIndex].id;
      if (num > 0) {
        if (that.localChooseRegionArr.length > 0) {
          let isadd = true
          for (let i = 0; i < that.localChooseRegionArr.length; i++) {
            if (id == that.localChooseRegionArr[i].id) {
              isadd = false
              let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
              obj.continentIndex = continentIndex
              obj.regionIndex = regionIndex
              that.localChooseRegionArr[i] = obj
            }
          }
          if (isadd) {
            let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
            obj.continentIndex = continentIndex
            obj.regionIndex = regionIndex
            that.localChooseRegionArr.push(obj)
          }
        } else if (that.localChooseRegionArr.length == 0) {
          let obj = that.localStaticCountryInfo[continentIndex].child[regionIndex]
          obj.continentIndex = continentIndex
          obj.regionIndex = regionIndex
          that.localChooseRegionArr.push(obj)
        }
      }
      that.clearChangeTime()
      that.refreshChooselocalTotalInfo()
    },
    cartDecIPNum: function (index) {
      let that = this;
      let del = false
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      let num = that.localChooseRegionArr[index].num
      let id = that.localChooseRegionArr[index].id
      num--
      if (num > 0) {
        that.localChooseRegionArr[index].num = num
      } else if (num == 0) {
        that.localChooseRegionArr[index].num = num
        del = true
      } else {
        num = 0
        that.localChooseRegionArr[index].num = num
        del = true
      }
      if (del) {
        if (that.localChooseRegionArr.length > 0) {
          that.localChooseRegionArr.splice(index, 1);
        }
      }
      that.changeAllAreaNum(continentIndex, regionIndex, id, num)
      that.refreshChooselocalTotalInfo(index)
    },
    cartDecIPNumReduce: function (index) {
      let that = this
      let num = that.localChooseRegionArr[index].num
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      let id = that.localChooseRegionArr[index].id
      that.changeNumTime = setTimeout(() => {
        that.changeNumIntervals = setInterval(() => {
          if (num > 0) {
            num--
          } else {
            that.clearChangeTime()
            return false
          }
          that.localChooseRegionArr[index].num = num
        }, 100);
      }, 500);
    },
    cartDecIPNumReduceStop: function (index) {
      let that = this
      let del = false
      let num = that.localChooseRegionArr[index].num;
      let id = that.localChooseRegionArr[index].id;
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      if (num == 0) {
        del = true
      }
      if (del) {
        if (that.localChooseRegionArr.length > 0) {
          that.localChooseRegionArr.splice(index, 1);
        }
      }
      that.changeAllAreaNum(continentIndex, regionIndex, id, num)
      that.clearChangeTime()
      that.refreshChooselocalTotalInfo()
    },
    cartAddIPNum: function (index) {
      let that = this;
      let num = that.localChooseRegionArr[index].num
      let maxNum = that.localChooseRegionArr[index].stock
      let id = that.localChooseRegionArr[index].id
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      if (num < maxNum) {
        num++
        that.localChooseRegionArr[index].num = num;
        that.changeAllAreaNum(continentIndex, regionIndex, id, that.localChooseRegionArr[index].num)
      }
      that.refreshChooselocalTotalInfo()
    },
    cartAddIPNumPlus: function (index) {
      let that = this
      let num = that.localChooseRegionArr[index].num
      let maxNum = that.localChooseRegionArr[index].stock
      let id = that.localChooseRegionArr[index].id
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      that.changeNumTime = setTimeout(() => {
        that.changeNumIntervals = setInterval(() => {
          if (num < maxNum) {
            // num = maxNum
            num++
          } else {
            that.clearChangeTime()
            return false
          }
          that.localChooseRegionArr[index].num = num;
        }, 100);
      }, 500);
    },
    cartAddIPNumPlusStop: function (index) {
      let that = this
      let num = that.localChooseRegionArr[index].num;
      let id = that.localChooseRegionArr[index].id
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      that.changeAllAreaNum(continentIndex, regionIndex, id, that.localChooseRegionArr[index].num)
      that.clearChangeTime()
      that.refreshChooselocalTotalInfo()
    },
    cartChangeInputNum: function (index) {
      let that = this;
      let del = false;
      let num = that.localChooseRegionArr[index].num;
      let continentIndex = that.localChooseRegionArr[index].continentIndex;
      let regionIndex = that.localChooseRegionArr[index].regionIndex;
      if (num !== '' && num[0] === '0') {
        num = num.slice(1);
      }
      const pattern = /^[1-9]\d*$/;
      if (!pattern.test(num)) {
        num = 0;
        del = true;
      } else {
        let maxNum = that.localChooseRegionArr[index].stock;
        if (num > maxNum) {
          num = maxNum;
        } else if (num == 0) {
          num = 0;
          del = true;
        } else if (num < 0) {
          num = 0;
          del = true;
        }
      }
      that.localChooseRegionArr[index].num = num;
      let id = that.localChooseRegionArr[index].id;
      if (del) {
        if (that.localChooseRegionArr.length > 0) {
          if (that.localChooseRegionArr.length > 0) {
            that.localChooseRegionArr.splice(index, 1);
          }
        }
      }
      that.changeAllAreaNum(continentIndex, regionIndex, id, that.localChooseRegionArr[index].num)
      that.refreshChooselocalTotalInfo()
    },
    clearChangeTime: function () {
      let that = this
      clearTimeout(that.changeNumTime);
      that.changeNumTime = "";
      clearInterval(that.changeNumIntervals);
      that.changeNumIntervals = "";
    },
    changeAllAreaNum: function (continentIndex, regionIndex, id, num) {
      let that = this
      if (that.localStaticCountryInfo[continentIndex].child && that.localStaticCountryInfo[continentIndex].child.length > 0 && that.localStaticCountryInfo[continentIndex].child != null) {
        let needLoop = true
        if (that.localStaticCountryInfo[continentIndex].child.length > regionIndex) {
          if (id == that.localStaticCountryInfo[continentIndex].child[regionIndex].id) {
            that.localStaticCountryInfo[continentIndex].child[regionIndex].num = num
            needLoop = false
          }
        }
        if (needLoop) {
          for (let i = 0, len = that.localStaticCountryInfo[continentIndex].child.length; i < len; i++) {
            if (that.localStaticCountryInfo[continentIndex].child[i].id == id) {
              that.localStaticCountryInfo[continentIndex].child[i].num = num
            }
          }
        }
      }
    },
  
    refreshChooselocalTotalInfo: function () {
      let that = this;
      let total = 0

      // if localPackageType not in typeArr types, then reset to monthly
      if (!that.typeArr.find(item => item.type === that.localPackageType)) {
        that.localPackageType = 'monthly'
      }

      if (that.localChooseRegionArr.length > 0) {
        for (let i = 0; i < that.localChooseRegionArr.length; i++) {
          total = total + (that.localChooseRegionArr[i].num * that.localChooseRegionArr[i][that.localPackageType + '_price'])
          total = that.roundTwoDecimal(total)
        }
        that.localTotalInfo.total = total
      } else {
        that.localTotalInfo.total = 0
      }
      that.saveCartData();
    },
    
    async loadUserAuthories() {
      let that = this;
      await getUserAuthorities({}).then(res => {
        if (res.data.show_test_ip) {
          that.maxTestIps = res.data.left_test_ips;

          // insert test to typeArr if not exist
          let testIndex = that.typeArr.findIndex(item => item.type === 'test');
          if (testIndex === -1) {
              that.typeArr.unshift(        {
              showname: that.$t('buy_isp.periods.test'),
              type: "test",
            });
          }
        }
      }).catch(e => {
        // that.$message.error(e.message ?? e.msg ?? "request user authories error");
      }).finally(() => {
        that.loading = false;
      });
    },

    async toObtainPlan() {
      let that = this;
      that.loading = true;

      let keyword = that.searchInfo.code.trim()
      await getIspPackages({ keyword: keyword }).then(res => {
        var areas = res.data.area;

        // merge country & code
        areas = areas.map(item => {
          if (item.city_code) {
            item.country_code = `${item.country_code}-${item.city_code}`;
            item.country_name = `${item.country_name}-${item.city_name}`;
          } else if (item.state_code) {
            item.country_code = `${item.country_code}-${item.state_code}`;
            item.country_name = `${item.country_name}-${item.state_name}`;
          }

          delete item.state_code;
          delete item.state_name;
          delete item.city_code;
          delete item.city_name;
          return item;
        });

        // transform area to expanded
        areas = areas.reduce((result, item) => {
          if (result[item.continent]) {
              result[item.continent].push(item);
          } else {
              result[item.continent] = [item];
          }
          return result;
        }, {});

        // 对每个分组的数组按照weight属性从大到小排序
        for (let continent in areas) {
          areas[continent].sort((a, b) => b.weight - a.weight);
        }

        areas = Object.keys(areas).map(key => {
            return {
                name: key,
                child: areas[key]
            };
        });

        that.expandedPanels = []
        for (let i = 0; i < areas.length; i++) {
          if (areas[i].child && areas[i].child.length > 0 && areas[i].child != null) {
            that.expandedPanels.push(areas[i].name)
            for (let k = 0; k < areas[i].child.length; k++) {
              areas[i].child[k].country_name_sp = that.$options.filters['sp_length'](areas[i].child[k].country_name);
              if (that.localChooseRegionArr.length > 0) {
                for (let j = 0; j < that.localChooseRegionArr.length; j++) {
                  if (areas[i].child[k].id == that.localChooseRegionArr[j].id) {
                    areas[i].child[k].num = that.localChooseRegionArr[j].num
                    break
                  } else {

                    areas[i].child[k].num = 0
                  }
                }
              } else {
                areas[i].child[k].num = 0
              }
            }
          }
        }

        that.localStaticCountryInfo = areas
        that.updatePlansScrollHint()
      }).catch(e => {
        // that.$message.error(e.message ?? e.msg ?? "request plan error");
      }).finally(() => {
        that.loading = false;
      });
    },
    
    roundTwoDecimal: function (num, decimal = 2) {
      let that = this;
      let num1 = num * 1;
      let numstr = num + '';
      if (numstr.indexOf('.') != -1) {
        let decimalLength = that.countDecimalPlaces(num);
        if (typeof decimal !== 'number') {
          decimal = 2;
        }
        if (decimalLength > decimal) {
          let multipleNum = Math.pow(10, decimal);
          num1 = Math.round(num * multipleNum) / multipleNum;
        }
      }
      return num1;
    },
    formatMoney(value) {
      const number = Number(value || 0);
      if (!Number.isFinite(number)) {
        return '0';
      }
      const rounded = Math.round(number * 100) / 100;
      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
    },
    countDecimalPlaces: function (num) {
      let str = num.toString();
      let dotIndex = str.indexOf(".");
      let decimalPlaces = str.length - dotIndex - 1;
      return decimalPlaces;
    },
  },
  filters: {
    sp_length (value) {
      if (!value) return ''
      if (value.length > 14) {
          if(value.includes('-')){
              let a = value.split('-');
              let text = '';
              for (let index = 1; index < a.length; index++) {
                  text = a[index-1] + '-<br>'
              }
              text = text + a[a.length-1];
              return text
          }else{
              let text = value.slice(0,14) + '<br>' + value.slice(14,99);
              return text
          }
      }else{
          return value;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-loading-mask {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-loading-spinner {
    margin: 0;
    width: fit-content;
  }
}

.summer-static-promo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 10px;
  padding: 9px 11px;
  border: 1px solid rgba(255, 138, 61, 0.3);
  border-radius: 14px;
  background:
    radial-gradient(circle at 88% 14%, rgba(247, 201, 72, 0.28), transparent 30%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.92), rgba(255, 244, 223, 0.92));
  box-shadow: 0 10px 20px rgba(255, 138, 61, 0.1);
}

.summer-static-promo strong {
  display: block;
  color: #8b4210;
  font-size: 13px;
  line-height: 18px;
}

.summer-static-promo span {
  display: block;
  margin-top: 2px;
  color: #5f7472;
  font-size: 11px;
  line-height: 15px;
}

.summer-static-promo em {
  flex: 0 0 auto;
  padding: 5px 8px;
  border-radius: 999px;
  color: #fff;
  background: #ff8a3d;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.static-isp-checkout-btn,
.static-isp-checkout-btn:hover,
.theme-summer .static-isp-checkout-btn,
.theme-summer .static-isp-checkout-btn:hover {
  color: #fff !important;
}

.proxy-plans-scroll {
  scrollbar-color: #b9c3d5 #f4f6fa;
  scrollbar-width: thin;
}

.proxy-plans-scroll::-webkit-scrollbar {
  width: 8px;
}

.proxy-plans-scroll::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #f4f6fa;
}

.proxy-plans-scroll::-webkit-scrollbar-thumb {
  border: 2px solid #f4f6fa;
  border-radius: 999px;
  background: #b9c3d5;
}

.proxy-scroll-hint {
  position: absolute;
  left: 50%;
  bottom: 10px;
  z-index: 12;
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(39, 109, 253, 0.2);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.94);
  color: #276dfd;
  box-shadow: 0 4px 14px rgba(34, 50, 101, 0.2);
  cursor: pointer;
  transform: translateX(-50%);
  animation: proxy-scroll-hint-bounce 1.6s ease-in-out infinite;
}

@keyframes proxy-scroll-hint-bounce {
  0%, 100% { transform: translate(-50%, 0); }
  50% { transform: translate(-50%, 5px); }
}

.theme-summer .isp-search-control {
  border-radius: 12px;
  box-shadow: 0 8px 18px rgba(18, 110, 106, 0.06);
}

.theme-summer .isp-search-control .el-icon-search {
  color: #126e6a !important;
}

.theme-summer .isp-search-input {
  height: 44px !important;
  border-color: rgba(18, 110, 106, 0.2) !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  color: #173b3a !important;
  font-weight: 500;
  box-shadow: 0 8px 18px rgba(18, 110, 106, 0.06);
}

.theme-summer .isp-search-input::placeholder {
  color: rgba(23, 59, 58, 0.42);
}

.theme-summer .isp-search-input:focus {
  border-color: rgba(255, 138, 61, 0.72) !important;
  outline: none;
  box-shadow: 0 0 0 4px rgba(255, 138, 61, 0.12), 0 10px 24px rgba(255, 138, 61, 0.1);
}

.theme-summer .isp-search-button {
  top: 5px !important;
  right: 5px !important;
  bottom: 5px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 74px !important;
  height: 34px !important;
  border-radius: 9px !important;
  background: linear-gradient(135deg, #ff8a3d, #f7b955) !important;
  color: #fff !important;
  line-height: 34px !important;
  box-shadow: 0 8px 18px rgba(255, 138, 61, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.theme-summer .isp-search-button:hover {
  background: linear-gradient(135deg, #ff7a22, #f4aa37) !important;
  box-shadow: 0 10px 22px rgba(255, 122, 34, 0.28);
  transform: translateY(-1px);
}

@media (max-width: 1500px), (max-height: 900px) {
  .proxy-summary {
    height: calc(100vh - 170px) !important;
    max-height: calc(100vh - 170px) !important;
    min-height: 0;
  }

  .proxy-skus {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 245px);
    max-height: calc(100vh - 245px);
  }

  .proxy-plans-container {
    flex: 1;
    height: auto !important;
    min-height: 0;
  }

  .proxy-summary-footer {
    padding-bottom: 18px !important;
  }
}

@media (max-width: 1440px) {
  .proxy-summary-footer a {
    width: 100% !important;
    max-width: 197px;
  }
}

@media (max-height: 760px) {
  .summer-static-promo {
    margin-bottom: 8px;
    padding: 7px 10px;
  }

  .summer-static-promo strong {
    font-size: 12px;
    line-height: 16px;
  }

  .summer-static-promo span {
    font-size: 10px;
    line-height: 14px;
  }

  .proxy-summary-footer {
    padding-bottom: 14px !important;
  }

  .proxy-summary-footer a {
    height: 40px !important;
    line-height: 40px !important;
    font-size: 17px !important;
  }
}
</style>
